import { createContext, useContext } from "react";
import * as beauty from "../../api/organizerBeautyApi";
import * as clients from "../../api/organizerClientsApi";

/* Adaptador de API de las fichas: los componentes de `organizer/clientes` hablan con esta interfaz y no con un
   endpoint. Hay dos: `clientesAdapter` (/api/organizer/clients, por negocio y para todos los rubros) y
   `beautyAdapter` (/api/organizer/beauty/clients, con el salón activo). Sin proveedor se usa el de Beauty, así la
   pestaña del salón y la ficha del turno siguen igual; el módulo "Clientes" provee el del negocio.
   Todos los métodos devuelven la respuesta de axios (`data.info`). */

export const clientesAdapter = {
  list: (params) => clients.clientsListApi(params),
  get: (id) => clients.clientsGetApi(id),
  update: (id, data) => clients.clientsUpdateApi(id, data),
  archive: (id) => clients.clientsArchiveApi(id),
  unarchive: (id) => clients.clientsUnarchiveApi(id),
  merge: (id, sourceIds) => clients.clientsMergeApi(id, sourceIds),
  history: (id) => clients.clientsHistoryApi(id),
  notes: (id) => clients.clientsNotesApi(id),
  addNote: (id, nota) => clients.clientsAddNoteApi(id, nota),
  updateNote: (id, noteId, data) => clients.clientsUpdateNoteApi(id, noteId, data),
  archiveNote: (id, noteId) => clients.clientsArchiveNoteApi(id, noteId),
  reservationClient: (rid) => clients.clientsReservationClientApi(rid),
  openReservationClient: (rid, body) => clients.clientsOpenReservationClientApi(rid, body),
  linkReservation: (rid, clientId) => clients.clientsLinkReservationClientApi(rid, clientId),
  unlinkReservation: (rid) => clients.clientsUnlinkReservationClientApi(rid),
};

// El historial de Beauty llega como `appointments`; se lo lleva a la forma por rubro (`items` con `kind`).
const historialBeauty = async (id) => {
  const res = await beauty.beautyClientAppointmentsApi(id);
  const info = res?.data?.info;
  if (res?.data?.isSuccess !== true || !info || !Array.isArray(info.appointments)) return res;
  const { appointments, ...resto } = info;
  return { ...res, data: { ...res.data, info: { ...resto, items: appointments.map((a) => ({ kind: "beauty", ...a })) } } };
};

export const beautyAdapter = {
  list: (params) => beauty.beautyListClientsApi(params),
  get: (id) => beauty.beautyGetClientApi(id),
  update: (id, data) => beauty.beautyUpdateClientApi(id, data),
  archive: (id) => beauty.beautyArchiveClientApi(id),
  unarchive: (id) => beauty.beautyUnarchiveClientApi(id),
  merge: (id, sourceIds) => beauty.beautyMergeClientApi(id, sourceIds),
  history: historialBeauty,
  notes: (id) => beauty.beautyClientNotesApi(id),
  addNote: (id, nota) => beauty.beautyAddClientNoteApi(id, nota),
  updateNote: (id, noteId, data) => beauty.beautyUpdateClientNoteApi(id, noteId, data),
  archiveNote: (id, noteId) => beauty.beautyArchiveClientNoteApi(id, noteId),
  reservationClient: (rid) => beauty.beautyAppointmentClientApi(rid),
  openReservationClient: (rid, body) => beauty.beautyOpenAppointmentClientApi(rid, body),
  linkReservation: (rid, clientId) => beauty.beautyLinkAppointmentClientApi(rid, clientId),
  unlinkReservation: (rid) => beauty.beautyUnlinkAppointmentClientApi(rid),
};

export const ClientesApiContext = createContext(beautyAdapter);
export const useClientesApi = () => useContext(ClientesApiContext);
